<div class="modal-header">
    <h4 class="modal-title"></h4>
  </div>
  <div class="modal-body">
    <p>Leave without saving changes?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-brand-main klaim_btn text-center" (click)="confirm()">Save & Exit</button>
    <button type="button" class="btn-dark-grey klaim_btn text-center" (click)="cancel()">Exit</button>
  </div>    